<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="JobSchedulerConfig"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :name="formName"
      :readonly="resource.locked"
      :labelAlign="$config.forms.defaultLabelAlign"
      :id="formId"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpRow>
        <ItpCol>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="name"
            :label="'Name'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            required
          >
            <ItpFormInput
              name="name"
              v-model="editor.name"
              required
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="suspended"
            :label="'Suspended'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
          >
            <ItpFormCheckbox
              name="suspended"
              v-model="editor.suspended"
            >
            </ItpFormCheckbox>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="notes"
            :label="'Notes'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
          >
            <ItpFormTextarea
              name="notes"
              v-model="editor.notes"
            >
            </ItpFormTextarea>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="function_name"
            :label="'Function'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            required
          >
            <ItpFormInput
              name="function_name"
              v-model="editor.function_name"
              required
            >
            </ItpFormInput>
            <ItpAlert
              show
              type="warning"
              class="mt-3"
              slot="description"
              v-if="resource.function_resolve_error"
            >
              <p>
                <ItpIcon
                  fa="exclamation-circle"
                >
                </ItpIcon>
                <ItpText
                  wrap
                >
                  {{ resource.function_resolve_error }}
                </ItpText>
              </p>
            </ItpAlert>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="crontab_trigger"
            :label="'Cron Tab Entry'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
          >
            <ItpFormInput
              name="crontab_trigger"
              v-model="editor.crontab_trigger"
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="3"
            name="jitter"
            :label="'Jitter'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
          >
            <ItpFormInput
              type="number"
              name="jitter"
              v-model="editor.jitter"
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="kwargs"
            :label="'Parameters'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
          >
            <CodeMirror
              mode="json"
              :options="b_7756430993412511_options"
              v-model="kwargs"
              class="border"
            >
            </CodeMirror>
          </ItpFormGroup>
        </ItpCol>
      </ItpRow>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Delete'|pgettext('Button')"
      variant="danger"
      icon="fa-times"
      :spinning="actions.delete.isRunning"
      class="mr-auto"
      @click.prevent.stop="evh_1548630417156826_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      :form="forms[formName] && forms[formName].id"
      :text="'Save'|pgettext('Button')"
      type="submit"
      variant="primary"
      default
      :spinning="actions.submit && actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|pgettext('Button')"
      variant="default"
      :disabled="actions.submit && actions.submit.isRunning"
      @click.prevent.stop="evh_2186679009640457_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class JobSchedulerConfig extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  resource!: any;

  async $$load_resource() {
    return this.oid
      ? this.$fn.fetch('read_job_scheduler_config', { parameters: { id: this.oid }, asResource: true })
      : this.$fn.schemaDefaults('CreateMethodSchedulerConfig')
  }

  editor!: any;

  async $$load_editor() {
    return this.resource.editor()
  }

  kwargs!: any;

  async $$load_kwargs() {
    return this.editor.kwargs ? JSON.stringify(this.editor.kwargs, null, 2) : null
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_7756430993412511_options!: any;
  dataMembers = ['resource', 'editor', 'kwargs', 'formId', 'formName', 'ux', 'b_7315092382398562_modalBindings', 'b_7756430993412511_options'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        resource: null,
        editor: null,
        kwargs: null,
        formId: null,
        formName: "JobSchedulerConfig",
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
        b_7756430993412511_options: {
          lineNumbers: true,
          matchBrackets: true,
          continueComments: "Enter",
          extraKeys: {
            "Ctrl-Q": "toggleComment",
          }
          ,
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.$fn.pgettext("JobSchedulerConfig|Title", "Job scheduler configuration")
          ,
        ]
        ,
        icon: this.$config.settings.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_4970_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_4970, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_4976_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_4976, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data,
      }
      ,
    }
  }

  async act_1040167445267876_crud_4974_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1040167445267876_crud_4974, alias=save
    return {
      objectType: "job_scheduler_config",
      op: "upsert",
      data: {
        ...this.editor.getData(),
        kwargs: this.kwargs ? JSON.parse(this.kwargs) : null,
      },
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_1548630417156826_closeModal_4980_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1548630417156826_closeModal_4980, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_1548630417156826_request_4978_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1548630417156826_request_4978, alias=delete
    return {
      operation: "delete_job_scheduler_config",
      data: this.resource.getData({ fields: ['id', 'etag'] }),
    }
  }

  async evh_1548630417156826_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2186679009640457_closeModal_4982_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_2186679009640457_closeModal_4982, alias=undefined
    return {
      name: this.modalName,
    }
  }

  async evh_2186679009640457_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_4970: actions.CloseModalAction;
    evh_7315092382398562_close_4969: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_4972: actions.CloseComponentAction;
    evh_2248226175642056_close_4971: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_4976: actions.CloseModalAction;
    evh_1040167445267876_success_4975: actions.EventHandlerImpl;
    act_1040167445267876_crud_4974: actions.CRUDAction;
    evh_1040167445267876_submit_4973: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1548630417156826_closeModal_4980: actions.CloseModalAction;
    evh_1548630417156826_success_4979: actions.EventHandlerImpl;
    act_1548630417156826_request_4978: actions.RequestAction;
    evh_1548630417156826_clickPreventStop_4977: actions.EventHandlerImpl;
    evh_1548630417156826_clickPreventStop: actions.EventHandlerGroup;
    act_2186679009640457_closeModal_4982: actions.CloseModalAction;
    evh_2186679009640457_clickPreventStop_4981: actions.EventHandlerImpl;
    evh_2186679009640457_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_4970 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_4970_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_4969 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_4970,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_4969],
      }
    );
    const act_2248226175642056_closeComponent_4972 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_4971 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_4972,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_4971],
      }
    );
    const act_1040167445267876_closeModal_4976 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_4976_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_4975 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_4976,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_crud_4974 = new actions.CRUDAction(
      {
        actionArgs: this.act_1040167445267876_crud_4974_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_4975],
      }
    );
    const evh_1040167445267876_submit_4973 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_crud_4974,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_4973],
      }
    );
    const act_1548630417156826_closeModal_4980 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1548630417156826_closeModal_4980_getActionArgs,
        events: [],
      }
    );
    const evh_1548630417156826_success_4979 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_closeModal_4980,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1548630417156826_request_4978 = new actions.RequestAction(
      {
        actionArgs: this.act_1548630417156826_request_4978_getActionArgs,
        displayName: "delete",
        events: [evh_1548630417156826_success_4979],
      }
    );
    const evh_1548630417156826_clickPreventStop_4977 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_request_4978,
        event: "click.prevent.stop",
        displayName: "delete",
      }
    );
    const evh_1548630417156826_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_clickPreventStop_4977],
      }
    );
    const act_2186679009640457_closeModal_4982 = new actions.CloseModalAction(
      {
        actionArgs: this.act_2186679009640457_closeModal_4982_getActionArgs,
        events: [],
      }
    );
    const evh_2186679009640457_clickPreventStop_4981 = new actions.EventHandlerImpl(
      {
        action: act_2186679009640457_closeModal_4982,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_2186679009640457_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2186679009640457_clickPreventStop_4981],
      }
    );
    return {
      act_7315092382398562_closeModal_4970,
      evh_7315092382398562_close_4969,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_4972,
      evh_2248226175642056_close_4971,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_4976,
      evh_1040167445267876_success_4975,
      act_1040167445267876_crud_4974,
      evh_1040167445267876_submit_4973,
      evh_1040167445267876_submit,
      act_1548630417156826_closeModal_4980,
      evh_1548630417156826_success_4979,
      act_1548630417156826_request_4978,
      evh_1548630417156826_clickPreventStop_4977,
      evh_1548630417156826_clickPreventStop,
      act_2186679009640457_closeModal_4982,
      evh_2186679009640457_clickPreventStop_4981,
      evh_2186679009640457_clickPreventStop,
      save: act_1040167445267876_crud_4974,
      delete: act_1548630417156826_request_4978,
    }
  }
}

Vue.component("JobSchedulerConfig", JobSchedulerConfig);

</script>